<ul class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs"
        class="breadcrumb-item">
      <a routerLink="{{breadcrumb.url}}">
        {{ breadcrumb.label }}
      </a>
    </li>
  </ul>